module.exports = __webpack_public_path__ + "static/img/cost.6646978b.svg";